// src/components/Tile.jsx
import React from 'react';
import './Tile.css';

function TileIcon({ name }) {
  const common = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };

  switch (name) {
    case 'gear':
      return <svg {...common}><path d="M4 8.5h16v10H4z"/><path d="M8 8.5V6.8A1.8 1.8 0 0 1 9.8 5h4.4A1.8 1.8 0 0 1 16 6.8v1.7"/><path d="M4 12h16"/><path d="M10 12v2h4v-2"/></svg>;
    case 'radio':
      return <svg {...common}><path d="M7 8h10a2 2 0 0 1 2 2v9H5v-9a2 2 0 0 1 2-2Z"/><path d="m8 8 7-3"/><path d="M15 4v4"/><circle cx="10" cy="13" r="2"/><path d="M15 12h1.5M15 15h1.5"/></svg>;
    case 'medic':
      return <svg {...common}><path d="M9 3h6v6h6v6h-6v6H9v-6H3V9h6Z"/></svg>;
    case 'calendar':
      return <svg {...common}><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/><path d="m8.5 15 2 2 5-5"/></svg>;
    case 'fire':
      return <svg {...common}><path d="M12 22c4 0 7-2.7 7-6.3 0-2.6-1.4-4.5-3.8-6.4.1 2-1 3.3-2 3.9.1-3.9-1.7-6.6-5-9.2.2 3.5-3.2 5.3-3.2 9.4C5 18.4 8.1 22 12 22Z"/><path d="M9.6 18.2c0-1.7 1.1-2.7 2.4-3.8 1.4 1.2 2.4 2.2 2.4 3.8 0 1.6-1.1 2.8-2.4 2.8s-2.4-1.2-2.4-2.8Z"/></svg>;
    case 'admin':
      return <svg {...common}><path d="M12 3 20 6v5c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6Z"/><path d="M9.5 12.5 11 14l3.8-4"/></svg>;
    case 'people':
      return <svg {...common}><circle cx="9" cy="8" r="3"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0"/><circle cx="17" cy="9" r="2.3"/><path d="M15.5 15.5A4.7 4.7 0 0 1 21 20"/></svg>;
    case 'link':
      return <svg {...common}><path d="M10.5 13.5 13.5 10.5"/><path d="M7.2 15.8 5.8 17.2a3.5 3.5 0 0 1-5-5l3-3a3.5 3.5 0 0 1 5 0" transform="translate(3 0)"/><path d="m13.8 8.2 1.4-1.4a3.5 3.5 0 0 1 5 5l-3 3a3.5 3.5 0 0 1-5 0"/></svg>;
    case 'message':
      return <svg {...common}><path d="M4 5h16v11H8l-4 4Z"/><path d="M8 9h8M8 12h5"/></svg>;
    case 'document':
      return <svg {...common}><path d="M6 3h8l4 4v14H6Z"/><path d="M14 3v5h5M9 12h6M9 16h6"/></svg>;
    case 'calculator':
      return <svg {...common}><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8v3H8z"/><path d="M8.5 14h.01M12 14h.01M15.5 14h.01M8.5 17.5h.01M12 17.5h.01M15.5 17.5h.01"/></svg>;
    case 'command':
      return <svg {...common}><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/><path d="M12 2v2M22 12h-2M12 22v-2M2 12h2"/></svg>;
    default:
      return <svg {...common}><path d="M5 12h14M13 6l6 6-6 6"/></svg>;
  }
}

export default function Tile({ title, description, href, logo, icon, onClick, variant = 'default' }) {
  const content = (
    <>
      <div className={`tile-icon-wrap${logo ? ' tile-icon-wrap--logo' : ''}`}>
        {logo ? <img src={logo} alt="" className="tile-logo" /> : <TileIcon name={icon} />}
      </div>
      <div className="tile-copy">
        <span className="tile-title">{title}</span>
        {description && <span className="tile-description">{description}</span>}
      </div>
      <span className="tile-arrow" aria-hidden="true">{href ? '↗' : '→'}</span>
    </>
  );

  const className = `tile tile--${variant}`;

  if (onClick) {
    return <button className={className} type="button" onClick={onClick}>{content}</button>;
  }

  return <a className={className} href={href} target="_blank" rel="noopener noreferrer">{content}</a>;
}
